import HomePage from "./Pages/HomePage";

import "./App.css";

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
